import {
    DEALERAGENTPROFILE_SUCCESS,
    DEALERAGENTPROFILE_FAILED,
    RESET_DEALERAGENTPROFILE,
    LOADING_DEALERAGENTPROFILE,
    NETWORK_ERROR_DEALERAGENTPROFILE
} from '../types/index'

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERAGENTPROFILE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERAGENTPROFILE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERAGENTPROFILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERAGENTPROFILE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERAGENTPROFILE:
            return (state = initialState);
        default:
            return state;
    }
};